import { isValid, format as format$1 } from "date-fns";
import { flow } from "../fp/flow/flow.js";
import { toDate } from "./toDate.js";
import "date-fns/fp/parseISO";
const format = (date, dateFormat) => flow(date, toDate, (date2) => {
  if (!isValid(date2)) {
    throw new Error("Invalid date input");
  }
  return format$1(date2, dateFormat);
});
export {
  format
};
